var React = require('react');

function Repeat (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M31.281 5.281l-5 5-.687.719.687.719 5 5 1.438-1.438L29.437 12H39c1.117 0 2 .883 2 2v22c0 1.117-.883 2-2 2H27v2h12c2.2 0 4-1.8 4-4V14c0-2.2-1.8-4-4-4h-9.563l3.282-3.281zM11 10c-2.2 0-4 1.8-4 4v22c0 2.2 1.8 4 4 4h9.563l-3.282 3.281 1.438 1.438 5-5 .687-.719-.687-.719-5-5-1.438 1.438L20.563 38H11c-1.117 0-2-.883-2-2V14c0-1.117.883-2 2-2h12v-2z"}));
}

Repeat.defaultProps = {"viewBox":"0 0 50 50"};

module.exports = Repeat;

Repeat.default = Repeat;
